import * as Yup from 'yup';

export const maxSubjectLength = 80;
export const maxEmailMessageLength = 1000;
export const maxSmsMessageLength = 160;
export const maxLinkButtonTextLength = 30;
export const maxUrlLength = 200;
export const blankFieldErrorMessage = 'This field cannot be blank.';

export const emailSharingSchema = Yup.object().shape({
  subject: Yup.string()
    .max(maxSubjectLength)
    .required(blankFieldErrorMessage),
  message: Yup.string()
    .max(maxEmailMessageLength)
    .required(blankFieldErrorMessage),
  linkButtonText: Yup.string()
    .max(maxLinkButtonTextLength)
    .required(blankFieldErrorMessage),
});

export const noLinkEmailSharingSchema = Yup.object().shape({
  subject: Yup.string()
    .max(maxSubjectLength)
    .required(blankFieldErrorMessage),
  message: Yup.string()
    .max(maxEmailMessageLength)
    .required(blankFieldErrorMessage),
});

export const smsSharingSchema = Yup.object().shape({
  message: Yup.string()
    .max(maxSmsMessageLength)
    .required(blankFieldErrorMessage),
});
